module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('home')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/logo2.png'),
      "alt": "OpenCabana"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu-wrapper no-print"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "sidebar-menu-item"
  }, [(_vm.routeName !== 'LocationList') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('locations')
      }
    }
  }, [_vm._v("BOOK A CABANA")]) : _vm._e(), _vm._v(" "), (_vm.routeName !== 'home') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('home')
      }
    }
  }, [_vm._v("Become a Hotel Partner")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area text-center"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [(!_vm.isLoggedIn) ? _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('login')
      }
    }
  }, [_vm._v("GUEST LOGIN")])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("LOGOUT")])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed494f56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar.vue
// module id = 610
// module chunks = 2